// extracted by mini-css-extract-plugin
module.exports = {"app":"App-styles_app__JEzUU"};